import Translation from "components/Translation"
import getConfig from "next/config"
import { useState } from "react"
import { MembershipApiItem } from "types/membership"
import { classNames } from "utils/dom-helpers"
import { toCurrency } from "utils/string-localization-helper"

type MembershipCardPreviewProps = {
    membership: MembershipApiItem
    primary_color: string
}

export default function MembershipCardPreview(props: MembershipCardPreviewProps) {
    const {
        membership,
        primary_color
    } = props
    const [is_active, toggleActive] = useState<boolean>(false)
    const is_subscription = !!membership.membershipSubscription
    const { NEXT_PUBLIC_STATIC_DOMAIN } = getConfig().publicRuntimeConfig

    return (
        <div
            className="w-[48%] border-gray-200 rounded-[3px] shadow-md border-[1px] mb-[2px] h-auto cursor-pointer hover:text-white pt-[4px] px-[5px] text-[4px]"
            onMouseEnter={() => {
                toggleActive(true)
            }}
            onMouseLeave={() => {
                toggleActive(false)
            }}
            style={{
                backgroundColor: is_active
                    ? primary_color
                    : `rgb(249 250 251)`,
                borderColor: is_active
                    ? `${primary_color}40`
                    : 'transparent',
            }}
        >
            <div className="flex flex-row items-start mb-[2px] betterhover:hover:text-white pt-[4px]">
                <div className="w-[32px]">
                    <div className="w-full rounded-[3px]">
                        <img
                            className="w-full h-[30px] object-cover rounded-t-[3px]"
                            src={
                                membership.imageUrl ||
                                `https://${NEXT_PUBLIC_STATIC_DOMAIN}/images/location/location_fallback.jpg`
                            }
                            alt="Membership Image"
                        />
                        <div
                            className={`${is_subscription
                                ? 'bg-orange-300'
                                : 'bg-purple-400'
                                } w-full text-center text-white h-[10px] flex justify-center items-center rounded-b-[3px] uppercase`}
                        >
                            <Translation
                                content_key={is_subscription ? "subscription" : "package"}
                            />
                        </div>
                    </div>
                </div>
                <div className="ml-[4px] mt-0">
                    <h1 className="text-[4px]">{membership.name}</h1>
                </div>
                <div
                    className={classNames(
                        'ml-auto px-[7px] rounded-full py-[2px] bg-white font-semibold mt-0',
                        is_active ? 'text-primary' : ''
                    )}
                >
                    <h1>{toCurrency(membership.price as number)}</h1>
                </div>
            </div>
            <p
                className={classNames(
                    'mb-[4px] mt-[2px]',
                    is_active ? 'text-white' : 'text-gray-400'
                )}
            >
                {membership.description}
            </p>
        </div>
    )
}